import { computed } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import { addMinutes, isAfter } from 'date-fns'
import { STORAGE_AD_FREE } from '@/constants'

const adFree = useLocalStorage(STORAGE_AD_FREE, { enabled: false, expiredAt: 0 })

export function useLocalAdFree() {
  const enabled = computed(() => {
    if (!adFree.value.enabled)
      return false
    if (isAfter(adFree.value.expiredAt, Date.now()))
      return true
    return false
  })

  function setEnableMinutes(minutes: number) {
    adFree.value.enabled = true
    adFree.value.expiredAt = addMinutes(Date.now(), minutes).getTime()
  }

  return {
    setEnableMinutes,
    enabled,
  }
}
